import Vue from 'vue'
import Router from 'vue-router'
import JourneyPage from './views/JourneyPage'
import HomePage from './views/HomePage'
import UnauthorizedPage from './views/UnauthorizedPage'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/journey/:activityId',
      name: 'journey',
      component: JourneyPage
    },
    {
      path: '/401',
      name: 'unauthorized',
      component: UnauthorizedPage
    }
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  ]
})

export default router
